import { inject, observer } from "mobx-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Heading } from "../../ui";
import { HeadingLink, HeadingProps } from "../../ui/Heading.component";
import { MagicLink } from "@inferno/renderer-shared-ui";
import { DatasourceFeedItem } from "./Datasource.component";
import { DatasourceTileProps } from "./DatasourceTile.component";

export const CalendarDatasourceTile = inject("store")(
  observer((props: DatasourceTileProps) => {
    const { store, title, content, feedId, displayHints, block, url = "#" } = props;
    const { t } = useTranslation();

    if (!store || !content?.length) {
      return null;
    }

    const heading: HeadingProps = useMemo(() => props.heading ?? { level: 2 }, [props.heading]);
    const { showEyebrow, showDateStamp } = displayHints;
    const header = useMemo(() => {
      const link: HeadingLink = {
        text: t("view_more"),
        label: `${t("view_more")} ${t("events")}`,
        url,
      };
      return title ? (
        <Heading {...heading} link={link}>
          <MagicLink to={url} sectionName="events" context="view_more">
            {title}
          </MagicLink>
        </Heading>
      ) : (
        <Heading {...heading} link={link}>
          <MagicLink to={url} sectionName="events" context="view_more">
            {t("events")}
          </MagicLink>
        </Heading>
      );
    }, [title, heading, url, t]);

    return (
      <div key={block.id} className={"component-calendar-feed"}>
        {header}
        <div className="feed-cards" data-block-id={block.id} suppressHydrationWarning={true}>
          <Grid columns={4}>
            {content.map((item, i) => {
              return (
                <DatasourceFeedItem
                  key={`feed-item-${feedId}-${(item as any).ref_id}-${i}`}
                  item={item}
                  displayHints={displayHints}
                  index={i}
                  showEyebrow={showEyebrow}
                  showDateStamp={showDateStamp}
                  microsite={store.microsite}
                />
              );
            })}
          </Grid>
        </div>
      </div>
    );
  }),
);

export default CalendarDatasourceTile;
